import React from "react";
import { Link } from "react-router-dom";
import FooterServiceNav from "./FooterServiceNav";
import serviceData from "../../components/services/services-one/ServicesOneData.json";

const Footer = () => {
  return (
    <>
      {/* footer Section Start */}
      <footer>
        {/* footer Top Section Start */}
        <div className="footer-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="footer-wedget-one">
                  <Link to="/">
                    <img
                      src={`/images/logo-white.svg`}
                      alt="Iron Wall X Security"
                    />
                  </Link>
                  <p>
                    Iron Wall X is Turkey's leading security company, providing
                    comprehensive protection services for businesses and
                    individuals. With cutting-edge technology and highly trained
                    personnel, we ensure your safety 24/7.
                  </p>
                  <div className="footer-social-profile">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/ironwallxsecurity">
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/ironwallxsecurity">
                          <i className="fa fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/ironwallxsecurity">
                          <i className="fa fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/ironwallxsecurity">
                          <i className="fa fa-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/@ironwallxsecurity">
                          <i className="fa fa-youtube-play" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget-menu">
                  <h2>Service links</h2>
                  <ul>
                    {serviceData.map((item) => (
                      <FooterServiceNav key={item.id} data={item} />
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget-menu">
                  <h2>Quick Links</h2>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/services-1">Our Services</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/">Terms of Service</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-wedget-four">
                  <h2>contact us </h2>
                  <div className="inner-box">
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-map-marker" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            Gayrattepe Mahallesi, Ömer Beşiktaş Sk. No:2, 34400
                            Kağıthane/Beşiktaş/İstanbul, Türkiye
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-envelope-o" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            info@ironwallx.com, support@ironwallx.com
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inner-item" style={{ display: "none" }}>
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-phone" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span
                            className="inner-text"
                            style={{ display: "none" }}
                          >
                            +90 XXX XXX XX XX, +90 XXX XXX XX XX
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer Top Section End */}
        {/* footer Bottom Section Start */}
        <div className="footer-bottom-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="copy-right">
                  <p>
                    © Copyright {new Date().getFullYear()}{" "}
                    <span>
                      <Link to="/">Iron Wall X Security</Link>
                    </span>{" "}
                    - All Rights Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer Bottom Section End */}
      </footer>
      {/* footer Section End */}
    </>
  );
};

export default Footer;
